import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { CuentaUsuarioModel, CuentasModel, ResponseOtrasCuentasModel } from '../../../../../model/Cuentas.model';
import { apiService } from '../../../../../service/api.service';
import { FormControl, FormGroup, Validators, ValidatorFn, FormGroupDirective, NgForm, FormBuilder } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
@Component({
  selector: 'app-modal-ficha-usuario',
  templateUrl: './modal-ficha-usuario.component.html',
  styleUrls: ['./modal-ficha-usuario.component.css']
})
export class ModalFichaUsuarioComponent implements OnInit {

  usuario = new CuentaUsuarioModel();
  public formUsuario: FormGroup;
  stateRutValido = new StateRut(); 
  dataSelects= new CuentasModel();
  disabledCrear = true
  arrayComunas = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalFichaUsuarioComponent>,
    private api: apiService,    
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.dataSelects = this.data.dataSelects;
    this.formUsuario = this.formBuilder.group({
      idPersona: new FormControl(''),
      rut: new FormControl('',[Validators.required]),
      nombre: new FormControl({ value: '', disabled: true }, [Validators.required]),
      apellidoPaterno: new FormControl({ value: '', disabled: true }, [Validators.required]),
      apellidoMaterno: new FormControl({ value: '', disabled: true }, [Validators.required]),
      estamento: new FormControl({ value: 0, disabled: true }, [Validators.required, Validators.min(1)]),
      region: new FormControl({ value: 0, disabled: true }, [Validators.required, Validators.min(1)]),
      comuna: new FormControl({ value: -1, disabled: true }, [Validators.required, Validators.min(0)]),
      correo: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
      },{validator:[,this.validarRut]}
    );
  }
  

  validarRut(formulario:FormGroup){
    let rut = formulario.get('rut').value != null ? formulario.get('rut').value  : ''
    let cRut = rut.replace(/[\.-]/g, '');
    cRut = cRut.toUpperCase();
    var patt = /^\d{1,8}[0-9K]$/;
    var ok = patt.test(cRut);
    var cStr = cRut.slice(0, -1);
    var cDig = cRut.slice(-1);
    var nSum = 0;
    var nVal = 0;
    var cVal = "";

    if (ok) {
        for (let nMul = 2; cStr != ""; nMul = (nMul == 7) ? 2 : nMul + 1) {
            nSum += Number(cStr.slice(-1)) * nMul;
            cStr = cStr.slice(0, -1);
        }
        nVal = 11 - (nSum % 11);
        switch (nVal) {
            case 11:
                cVal = "0";
                break;
            case 10:
                cVal = "K";
                break;
            default:
                cVal = nVal.toString();
        }
        ok = cVal == cDig;
    }
    if(!ok && cRut.length >= 8 ){  
      return {rutValido:true};
    }else if(ok && (cRut.length >= 8 && cRut.length <=10)){ 
      return null;  
    } 
 
  }

  public hasError = (controlName: string, errorName: string) =>{
    return this.formUsuario.controls[controlName].hasError(errorName);
  }

  
  buscar(){ 
    if(this.formUsuario.controls['rut'].value != '' ){
      const rut =this.formUsuario.controls['rut'].value.replace('-','')
      this.api.API_POST_buscarPersona(rut).subscribe((response: ResponseOtrasCuentasModel) => {
        this.llenarForm(response.payload);
        this.enableForm();
      },
      (err) => {
        console.log(err)
      })
    }
  }

  llenarForm(data){
    const keys = Object.keys(this.formUsuario.controls);
    keys.forEach(key => {
      if(key == 'comuna' && data[key] == 0){
        data[key] = -1;
      }
      this.formUsuario.controls[key].setValue(data[key]);
    });
  }

  enableForm(){
    const keys = Object.keys(this.formUsuario.controls);
    keys.forEach(key => {
      this.formUsuario.controls[key].enable();
    });
  }

  seleccionarRegion(){
    const indexRegion =this.dataSelects.regiones.map(element => element.idRegion).indexOf(this.formUsuario.controls['region'].value);
    this.arrayComunas = this.dataSelects.regiones[indexRegion].comunas;
  }

  guardar(){
    const keys = Object.keys(this.usuario);
    keys.forEach(key => {
      this.usuario[key] = this.formUsuario.controls[key].value;
    }); 

    if(this.formUsuario.valid){
      this.api.API_POST_crearCuentaUsuario(this.usuario).subscribe((response) => {       
        this.dialogRef.close(this.usuario);
      },
      (err) => {
        console.log(err)
      })
    }
  }
}

export class StateRut implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form:  FormGroupDirective | NgForm | null): boolean {
    const dirty = control.dirty;
    if ( dirty !== null ) {
      return dirty && control.invalid;
    }
  }
}